import React from 'react';

import TextField from '../Molecules/TextField';
import NumberField from '../Molecules/NumberField';
import SelectField from '../Molecules/SelectField';
import YearMonthField from '../Atoms/YearMonthField';
import SingleNextButton from '../Atoms/SingleNextButton';
import StepShell from '../StepComponents/StepShell';
import Form from '../StepComponents/Form';
import { getApp, setApp } from '../../index';
import { nameRegex, currencyRegex } from '../../Utils/ValidationPatterns';
import { employmentStatuses } from '../../Utils/SelectOptions';


class StepCoApplicantEmployment extends React.Component {

    constructor(props) {
        super(props)
        var vwCoAppEmp = getApp("caEmploymentStatus");
        this.state = {
            employment: '',
            checked: vwCoAppEmp
        }
    }

    employmentCond() {
        var employmentStatus = getApp('caEmploymentStatus');
        this.setState({employment: employmentStatus});
        if(employmentStatus === "Self-Employed" || employmentStatus === "employed") {
            setApp({caEmployer: ""});
        }else{
            setApp({caEmployer: employmentStatus});
        }
    }

    checkboxCheck(event) {
        this.setState({checked: !this.state.checked});
        setApp('caVWEmployee', !this.state.checked);
    }

    render() {
        var rFirstName = getApp('ca_fname');
        var caFirstName = rFirstName.charAt(0).toUpperCase() + rFirstName.slice(1);
        let fields;
        var employment = this.state.employment;
        if(employment === "Employed") {
            setApp('caEmployer', '');
            setApp('caPosition', '');
            fields = (
                <div>
                   <TextField name="caEmployer" label="Employer" required={true} pattern={nameRegex} />
                   <YearMonthField yearsName="caYearsEmployer" yearsLabel={`${caFirstName}'s Years with Employer`} monthsName="caMonthsEmployer" monthsLabel={`${caFirstName}'s Months with Employer`} />
                    <TextField name="caPosition" label="Position or Title" required={true} />
                    <div className="hug">
                        <NumberField name="caAnnualIncome" prefix="$" pattern={currencyRegex} label={`${caFirstName}'s Gross Annual Income`} required={true} />
                        <span className="helper-text">What they make before taxes.</span>
                    </div>

                    <div className="loanApp-checkbox hug">
                        <input type="checkbox" name="caVWEmployee" value="yes" className="pull-left loanApp-form-control" onChange={this.checkboxCheck.bind(this)} defaultChecked={this.state.checked} />
                        <label htmlFor="caVWEmployee">Check this box if {caFirstName} is a Vantage West Employee</label>
                    </div>
                    <SingleNextButton nextBtnTxt="next" />
                </div>
            );
        }else if(employment === "Self-Employed") {
            setApp('caEmployer', '');
            setApp('caPosition', '');
            fields = (
                <div>
                    <TextField name="caEmployer" label={`${caFirstName}'s Company Name (optional)`} required={false} pattern={nameRegex} />
                    <YearMonthField yearsName="caYearsEmployer" yearsLabel={`${caFirstName}'s Years with Employer`} monthsName="caMonthsEmployer" monthsLabel={`${caFirstName}'s Months with Employer`} />
                    <TextField name="caPosition" label="Position or Title" required={true} />
                    <div className="hug">
                        <NumberField name="caAnnualIncome" prefix="$" pattern={currencyRegex} label={`${caFirstName}'s Gross Annual Income`} required={true} />
                        <span className="helper-text">What they make before taxes.</span>
                    </div>
                    <SingleNextButton nextBtnTxt="next" />
                </div>
            );
        }else if(employment === "Retired"){
            setApp('caEmployer', 'retired');
            setApp('caPosition', 'retired');
            fields = (
                <div>
                    <div className="hug">
                        <TextField name="caIncomeSource" label={`${caFirstName}'s Soure of Income`} required={true}/>
                        <span className="helper-text">e.g. Social Security, Savings, Retirement Fund, etc.</span>
                    </div>
                    <div className="hug">
                        <NumberField name="caAnnualIncome" prefix="$" pattern={currencyRegex} label={`${caFirstName}'s Gross Annual Income`} required={true} />
                        <span className="helper-text">What they make before taxes.</span>
                    </div>
                    <SingleNextButton nextBtnTxt="next" />
                </div>
            );
        }else if(employment === "Unemployed"){
            setApp('caEmployer', 'unemployed');
            setApp('caPosition', 'unemployed');
            fields = (
                <div>
                    <div className="hug">
                        <NumberField name="caAnnualIncome" prefix="$" pattern={currencyRegex} label={`${caFirstName}'s Gross Annual Income`} required={true} />
                        <span className="helper-text">What they make before taxes.</span>
                        <YearMonthField yearsName="caYearsUnemployed" yearsLabel="Years Unemployed" monthsName="caMonthsUnemployed" monthsLabel="Months Unemployed" />
                    </div>
                    <SingleNextButton nextBtnTxt="next" />
                </div>
            );
        }else{
            fields = (
                <div></div>
            );
        }

        return (
            <StepShell stepID="StepCoApplicantEmployment"
                friendlyText={`Now we need to know about where ${caFirstName} works.`}
                requestText=""
                progress="80%"
                backLink="/loan-application/co-applicant-contact"
                progressLabel="Co-Applicant Work"
            >
                <Form nextLink="/loan-application/authorized-user">
                    <div onChange={this.employmentCond.bind(this)} >
                        <SelectField options={employmentStatuses} required={true} name="caEmploymentStatus" placeholder="Employment Status" label="Employment Status" labelType="bold" />
                    </div>
                    {fields}                    
                </Form>             
            </StepShell>
        )
    }
}

export default StepCoApplicantEmployment;